// Clinic Configuration for Still Water Dental Care and Orthodontics
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Still Water Dental Care and Orthodontics",
  clinicId: "dentistinstillwater",
  clinicUrl: "https://stillwaterdentalcareandortho.com",

  // Contact Information
  phoneNumber: "254-492-3224",
  phoneNumberRaw: "+12544923224", // For tel: and sms: links
  email: "dentalcare@stillwaterdentalcareandortho.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinstillwater&agentId=28bf5aee-5b07-4fed-8947-e41e5f8d19a7",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinstillwater/voice",

  // Location
  address: "5619 W Loop 1604 N Suite 112, San Antonio, TX 78253, United States",
  addressShort: "5619 W Loop 1604 N Suite 112, San Antonio, TX 78253",
  city: "San Antonio",
  hcity: "San-Antonio",
  state: "Texas",
  stateShortForm: "TX",
  PostalCode: "78253",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/jeaRMkP3vheCf3TE8",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3300.944611613831!2d-98.7076654!3d29.493773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c426318945b81%3A0x75081dd689964170!2sStillwater%20Dental%20Care%20%26%20Orthodontics!5e1!3m2!1sen!2sin!4v1760430517252!5m2!1sen!2sin',

  iframeTitle: "Still Water Dental Care and Orthodontics",

  //membership
  membership: "",

  // Sunbit
  sunbitUrl: "https://stillwaterdentalcareandortho.com/patient-portal",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/stillwater-dental-care--ortho---dentist-in-stillwater?utm_source=practice&utm_medium=email&m=66577",


  // Analytics
  gaMeasurementId: "G-LNG0J8CZYX",
  clarityProjectId: "prc4w966rh",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinstillwater",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinstillwater",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinstillwater",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://stillwaterdentalcareandortho.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61575076085636#",
    instagram: "https://www.instagram.com/stillwater_dentist/",
    twitter: "https://x.com/StillWaterDent",
    linkedin: "https://www.linkedin.com/company/dentist-in-stillwater/",
    youtube: "https://www.youtube.com/@StillWaterDentist",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/14555991102121623891/profile?hl=en-GB&fid=8433023109519786352",
    facebook: "https://www.facebook.com/stillwaterdentalcare/",
    yelp: "",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 11,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 7,
      AppointmentTypeNum: 12,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 11,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 7,
    },
  ],


  // Twilio Configuration
  twilioPhoneNumber: "12543213515",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
